module.exports = __webpack_public_path__ + "static/media/llavero.fa7118f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/llavero.jpg
// module id = 1299
// module chunks = 0